import 'zone.js';
(window as any).global = window;
(window as any).process = { env: { DEBUG: undefined } };
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err =>
    {
     console.log("Bootstrap FAILED: ", err)
     document.body.innerHTML = '<pre>' + err + '</pre>'
    }
    );
